import { Injectable } from '@angular/core';

const STORAGE_KEY = 'temporary-study-items';

@Injectable({
  providedIn: 'root',
})
export class TemporaryStudyItemsService {
  private items: string[] = [];

  constructor() {
    this.loadItems();
  }

  private loadItems(): void {
    const storedItems = localStorage.getItem(STORAGE_KEY);
    this.items = storedItems ? JSON.parse(storedItems) : [];
  }

  private saveItems(): void {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(this.items));
  }

  getItems(): string[] {
    return [...this.items];
  }

  addItem(itemId: string): void {
    if (!this.items.includes(itemId)) {
      this.items.push(itemId);
      this.saveItems();
    }
  }

  addItems(itemIds: string[]): void {
    const newItems = itemIds.filter(id => !this.items.includes(id));
    if (newItems.length > 0) {
      this.items.push(...newItems);
      this.saveItems();
    }
  }

  removeItem(itemId: string): void {
    const index = this.items.indexOf(itemId);
    if (index > -1) {
      this.items.splice(index, 1);
      this.saveItems();
    }
  }

  clearItems(): void {
    this.items = [];
    this.saveItems();
  }

  hasItem(itemId: string): boolean {
    return this.items.includes(itemId);
  }
}
